import React, { useEffect, useMemo, useState, useRef } from "react";
import Layout from "../component/Layout/Layout";
import { useTryon } from "../context/TryOnContext";
import SocialShare from "../pages/SocialShare";
import { useAuth } from "../context/auth";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

export default function TryOnDetailPage() {
  const { tryon, removeFromTryon, refreshTryon } = useTryon();
  const [auth] = useAuth();
  const getWeekKey = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), 0, 1);
    const pastDays = Math.floor((now - firstDay) / 86400000);
    const week = Math.ceil((pastDays + firstDay.getDay() + 1) / 7);
    return `${now.getFullYear()}-W${week}`;
  };
  const [selected, setSelected] = useState([]);
  const [usedCount, setUsedCount] = useState(tryon?.week_completed || 0);

  const [isOpen, setIsOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [confirmed, setConfirmed] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);

  const [selectedDress, setSelectedDress] = useState(null);
  const [resultImage, setResultImage] = useState(null);
  const [modelImage, setModelImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");


  const toggleDress = (dress) => {
    const exists = selected.find((item) => item.id === dress.id);

    if (exists) {
      setSelected(selected.filter((item) => item.id !== dress.id));
      return;
    }

    if (selected.length < 3) {
      setSelected([...selected, dress]);
    } else {
      alert("You can select only 3 dresses for one try-on.");
    }
  };

  const handleStartTryOn = (dress) => {
    setSelectedDress(
      `${process.env.REACT_APP_IMAGE_URL}product/thumbnail/${dress?.product?.thumbnail}`,
    );

    if (!selected.length) return;

    //console.log(dress)

    if (usedCount === 0) {
      alert("Your weekly try-on limit is finished.");
      return;
    }
  };

  const closeModal = () => {
    setIsOpen(false);
    setPreview(null);
    setConfirmed(false);
    setUploadedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleAreaClick = () => {
    if (!preview && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFile = async (e) => {
    e.stopPropagation();
    const file = e.target.files?.[0];
    if (!file) return;

    setUploadedFile(file);
    /* const faceimageUrl = file
      ? URL.createObjectURL(file)
      : tryon?.user?.img_ai_tryon
        ? `${process.env.REACT_APP_IMAGE_URL}aitryon/${tryon[0].user.img_ai_tryon}`
        : null; */
    const faceimageUrl = file
      ? URL.createObjectURL(file)
      : tryon?.list?.[0]?.user?.img_ai_tryon
        ? `${process.env.REACT_APP_IMAGE_URL}aitryon/${tryon.list[0].user.img_ai_tryon}`
        : null;

    setPreview(faceimageUrl);

    setConfirmed(false);

    const formData = new FormData();
    formData.append("image", file);
    formData.append("user_id", auth?.user.id);

    // ✅ Debug properly
    for (let pair of formData.entries()) {
      //console.log(pair[0], pair[1]);
    }
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/customer/aitryon/faceupload`,
        formData
      );

      console.log(res.data);
      alert("Upload success");
    } catch (error) {
      console.error(error);
      alert("Upload failed");
    }
  };

  const handleUsePhoto = async () => {
    /* console.log(uploadedFile)
    if (!uploadedFile) return;

    setConfirmed(true);

    const newCount = usedCount + 1;
    localStorage.setItem(
      "tryon_usage",
      JSON.stringify({
        weekKey: getWeekKey(),
        usedCount: newCount,
      }),
    );
    setUsedCount(newCount);

    const formData = new FormData();
    formData.append("photo", uploadedFile);
    formData.append("selected_dresses", JSON.stringify(selected));

    console.log("API payload ready:", selected);
    // await axios.post('/api/tryon', formData)

    setSelected([]); */

  };

  const handleTryAnother = () => {
    setPreview(null);
    setConfirmed(false);
    setUploadedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };
  const handleDeleteTryOn = async (userId, productId) => {
    if (!window.confirm("Are you sure you want to remove this item?")) return;
    // removeFromTryon(userId, productId, 1);
    await removeFromTryon(userId, productId, 0);
    toast.success("Removed successfully!");
    //alert("Removed successfully!");
  };

  const handleDownloadImage = async (dress) => {
    //console.log(dress?.ai_image)
    //const imageUrl = `${process.env.REACT_APP_IMAGE_URL}product/thumbnail/${dress?.product?.thumbnail}`;

    const imageUrl = dress?.ai_image
  ? `${process.env.REACT_APP_IMAGE_URL}try_uploads/${dress.ai_image}`
  : `${process.env.REACT_APP_IMAGE_URL}product/thumbnail/${dress?.product?.thumbnail}`;
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      setResultImage(response?.data?.image_url);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${dress?.product?.name || "tryon-image"}.jpg`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Image download failed");
    }
  };

  const handleCopyClick = async () => {
    //alert("Copied to clipboard!");
    try {
      await navigator.clipboard.writeText(window.location.href);
      alert("Copied to clipboard!");
    } catch (err) {
      console.error("Unable to copy to clipboard.", err);
      alert("Copy to clipboard failed.");
    }
  };


  useEffect(() => {
    if (tryon?.week_completed !== undefined) {
      setUsedCount(tryon.week_completed);
    }

    if (!isOpen) return;

    const userImage = tryon?.list?.[0]?.user?.img_ai_tryon;

    if (userImage) {
      setPreview(`${process.env.REACT_APP_IMAGE_URL}aitryon/${userImage}`);
    } else {
      setPreview(null); // optional fallback reset
    }



  }, [isOpen, tryon]);

  const handleTryOnClick = (e, dress) => {
    //console.log(dress)
    e.stopPropagation();

    // ❗ Check limit first
    if (usedCount >= 3) {
      alert("Your weekly try-on limit is finished.");
      return;
    }

    setIsOpen(true);
    toggleDress(dress);
    handleStartTryOn(dress);
  };

  const handleStartTryOnSync = async (dress) => {
    //console.log(selected[0].id)
    if (!preview) alert("Please upload model image.");
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("image", selectedDress);
      formData.append("user_id", auth?.user.id);
      formData.append("try_id", selected[0]?.id);

      // ✅ Debug
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/customer/aitryon/start`,
        formData,   // ✅ DIRECT
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      //console.log(res.data.data);
      if (res.data.data.status === "starting") setStatus("Initializing...");
      if (res.data.data.status === "processing") setStatus("Generating AI image...");
      if (res.data.data.status === "completed") setStatus("Done ✅");

      if (res.data.data.status === "completed") {
        setResultImage(res.data.data.output[0]);
        setLoading(false);
        //refreshTryon(res.data.data);
          setTimeout(() => {
          window.location.reload();
          }, 1000);
      }
      if (res.data.data.status === "failed") {
        setLoading(false);
        setStatus("Failed ❌");
      }

    } catch (err) {
      console.error(err.response?.data || err.message);
      alert("Try-on failed");
      setLoading(false);
    }
  };

  return (
    <>
      <Layout>
        <div className="container p-4 pb-md-5 tryondetail-box">
          <div className="card border-0 rounded-4">
            <div className="card-body px-0 pb-4 pt-0">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
                <div>
                  <h1 className="h2 fw-bold mb-2">AI Virtual Try-On</h1>
                  {/* <p className="text-muted mb-0">
                    Select any <strong>3 dresses</strong> for your look preview.
                  </p> */}
                </div>
                <div className="bg-dark text-white rounded-4 px-4 py-3">
                  <div className="small opacity-75">Free Weekly Credits</div>
                  <div className="h4 fw-bold mb-0">{usedCount} / 3 left</div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row g-4">
            {tryon.map((dress) => {
              const isSelected = selected.some((item) => item?.product?.id === dress?.product?.id);
              return (
                <div className="col-12 col-md-4 col-lg-3" key={dress?.product?.id}>
                  <div className="productlist-box">

                    {dress?.status === 1 ? (
                      <>
                        <span
                          className="shareicon"
                          title="Download Try-On Result"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDownloadImage(dress);
                          }}
                        >
                          <i className="fa-solid fa-download"></i>
                        </span>
                        <span className="productlink"><Link to={`/product/${dress?.product?.slug}`} target="_blank">View Product</Link></span>
                        <div
                          className={`productlist`}
                        >
                          <div className="tryonbox-img">
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}product/thumbnail/${dress?.ai_image || dress?.product?.thumbnail}`}
                              alt={dress?.product?.name}
                              className="card-img-top"
                              style={{ aspectRatio: "2/3", objectFit: "cover" }}
                            />
                          </div>
                          <div className="producttitle">
                            <h2>{dress?.product?.name}</h2>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <span
                          className="trashicon"
                          title="Remove from Tryon List"
                          onClick={() =>
                            handleDeleteTryOn(dress?.customer_id, dress?.product_id)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fa-regular fa-trash-can"></i>
                        </span>
                        <span className="productlink"><Link to={`/product/${dress?.product?.slug}`} target="_blank">View Product</Link></span>
                        <div
                          className={`productlist ${isSelected ? "selected" : ""}`}
                          style={{ cursor: "pointer", transition: "0.2s" }}
                          onClick={() => toggleDress(dress)}
                        >
                          <div className="tryonbox-img">
                            <span
                              className={`checked-box-wrap ${isSelected ? "text-bg-dark" : "text-bg-light"
                                }`}
                            >
                              <span></span>
                              {isSelected ? "Selected" : "Choose"}
                            </span>

                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}product/thumbnail/${dress?.product?.thumbnail}`}
                              alt={dress?.product?.name}
                              className="card-img-top"
                              style={{ aspectRatio: "2/3", objectFit: "cover" }}
                            />

                          </div>
                          <div className="producttitle">
                            <h2>{dress?.product?.name}</h2>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div> */}

          <div className="row g-4">
            {tryon?.list?.map((dress) => {
              return (
                <div
                  className="col-12 col-md-4 col-lg-3"
                  key={dress?.product?.id}
                >
                  <div className="productlist-box">
                    {dress?.status === 1 ? (
                      <>
                        {/* Download Icon */}
                        <span
                          className="shareicon"
                          title="Download Try-On Result"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDownloadImage(dress);
                          }}
                        >
                          <i className="fa-solid fa-download"></i>
                        </span>



                        {/* Image */}
                        <div className="productlist">
                          <div className="tryonbox-img">
                            <img
                            src={`${
                            dress?.ai_image
                            ? process.env.REACT_APP_IMAGE_URL + "try_uploads/" + dress.ai_image
                            : process.env.REACT_APP_IMAGE_URL + "product/thumbnail/" + dress?.product?.thumbnail
                            }`}
                              alt={dress?.product?.name}
                              className="card-img-top product-img"
                            />
                            {/* View Product */}
                            <span className="productlink">
                              <Link
                                to={`/product/${dress?.product?.slug}`}
                                target="_blank"
                              >
                                View Product
                              </Link>
                            </span>
                          </div>

                          <div className="producttitle">
                            <h2>{dress?.product?.name}</h2>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* Delete Icon */}
                        <span
                          className="trashicon"
                          title="Remove from Tryon List"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleDeleteTryOn(
                              dress?.customer_id,
                              dress?.product_id,
                            )
                          }
                        >
                          <i className="fa-regular fa-trash-can"></i>
                        </span>



                        {/* Product Card with Hover */}
                        <div className="productlist">
                          <div className="tryonbox-img hover-container">
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}product/thumbnail/${dress?.product?.thumbnail}`}
                              alt={dress?.product?.name}
                              className="card-img-top product-img"
                            />

                            {/* Hover Overlay Button */}
                            <div className="hover-overlay">
                              <button
                                className="tryon-btn"
                                onClick={(e) => handleTryOnClick(e, dress)}
                              >
                                Start Free Try-On
                              </button>
                            </div>

                            {/* View Product */}
                            <span className="productlink">
                              <Link
                                to={`/product/${dress?.product?.slug}`}
                                target="_blank"
                              >
                                View Product
                              </Link>
                            </span>
                          </div>

                          <div className="producttitle">
                            <h2>{dress?.product?.name}</h2>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Layout>

       {isOpen && (
        <div className={`tryon-popup modal-overlay ${confirmed ? "active-tryon" : ""}`}>
          <div className="modal-overlay-box" onClick={closeModal}></div>

          <div className="modal-box">
            <div className="modal-header">
              <span>Chaashni By MK – Personalized Digital Fittings</span>
              <span className="close-btn" onClick={closeModal}>×</span>
            </div>

            <div className="upload-area" onClick={handleAreaClick}>
              <input
                type="file"
                ref={fileInputRef}
                accept="image/*"
                capture="environment"
                onChange={handleFile}
                name="image"
                style={{ display: "none" }}
              />

              {!preview ? (
                <>
                  <div className="upload-icon">
                    <i className="fa-solid fa-cloud-arrow-up"></i>
                  </div>
                  <p>Click anywhere to upload a full body photo</p>
                </>
              ) : (
                <>
                  <img src={preview} alt="preview" className="preview" />

                  {!confirmed && (
                    <div className="btn-group">
                      <button
                      className="use-btn flex items-center gap-2"
                      onClick={() => handleStartTryOnSync(selectedDress)}
                      disabled={loading}
                      >
                      {loading && (
                      <span className="animate-spin border-2 border-white border-t-transparent rounded-full w-4 h-4"></span>
                      )}
                      {loading
                      ? status || "Processing..."
                      : "Try On Now"}
                      </button>
                      <button className="retry-btn" onClick={handleTryAnother}>
                        Try Another
                      </button>
                    </div>
                  )}

                  {confirmed && (
                    <div className="success-text-box">
                      <p className="success-text">✅ {/* <i className="fa-regular fa-square-check"></i> */} Photo selected</p>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
